<template>
    <Card class="resetPWCard md:p-5 w-full md:w-8 lg:w-8">
        <template #title>
            <div class="text-center Paragraph-Medium">
               Password reset successful
            </div>
        </template>
        <template #subtitle>
            <div class="text-center Caption">
                Your password is successfully reset, now you can login to you account.
                </div>
        </template>
        <template #content>
                <div class="flex-column flex align-items-center pt-6">
                <Button label="Login" class="teal-700-button" @click="Login"/>          
            </div>
        </template>
    </Card>
</template>
<script setup>
import Card from 'primevue/card';
import Button from 'primevue/button';
import { useRouter } from 'vue-router';

const router = useRouter();

const Login = async () => {
   router.push('/login');
}
</script>
<style scoped>
.resetPWCard {
  border: none;
  box-shadow: none;
}
</style>
